import { withFormik } from "formik"
import moment from "moment"
import * as Yup from "yup"
import { emptyBankAccount } from "./constants"
import DevolucionForm from "./form"

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    empresaId: Yup.string().required(t("errors.clientRequired")),
    descripcion: Yup.string().nullable(),
    importe: Yup.number()
      .required(t("errors.importRequired"))
      .typeError(t("errors.numericValue")),
    fecha: Yup.date()
      .max(moment(new Date()), t("errors.previousDateCurrent"))
      .required(t("errors.dateRequired")),
    cuentaBancaria: Yup.object()
      .shape({
        bic: Yup.string(),
        cuentaIdExterno: Yup.string().required(t("errors.selectedOnePlease")),
        iban: Yup.string(),
      })
      .nullable(),
  })

const NewDevolucionForm = withFormik({
  validateOnChange: true,
  validateOnBlur: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data }) => {
    return {
      descripcion: data?.descripcion || null,
      importe: data?.importe || "",
      empresaContactoId: data?.contactoId || "",
      empresaId: data?.empresaId || "",
      fecha: moment(data?.fecha).format("YYYY-MM-DD"),
      cuentaBancaria: data?.cuentaBancaria || {
        bic: "",
        cuentaIdExterno: "",
        iban: "",
      },
    }
  },
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),

  handleSubmit: async (values, { props }) => {
    const modifiedValues = {
      cuentaBancariaId:
        values.cuentaBancaria.iban === emptyBankAccount.iban
          ? null
          : values.cuentaBancaria.cuentaIdExterno,
      descripcion: values.descripcion,
      fecha: values.fecha,
      importe: values.importe,
      empresaId: values.empresaId,
    }
    // @ts-expect-error TS(2339): Property 'data' does not exist on type 'object'.
    if (!props.data) {
      // @ts-expect-error TS(2339): Property 'handleCreate' does not exist on type 'ob...
      props.handleCreate(modifiedValues)
    } else {
      // @ts-expect-error TS(2339): Property 'handleEdit' does not exist on type 'obje...
      props.handleEdit({
        data: modifiedValues,
        // @ts-expect-error TS(2339): Property 'data' does not exist on type 'object'.
        id: props.data.id,
      })
    }
  },
})(DevolucionForm)

export default NewDevolucionForm
